/* ============================================================
   CMD REBRAND — Animation Engine v4
   Scroll reveals, counters, parallax, sticky header, timeline
   ============================================================ */
(function(){
  'use strict';
  var raf = requestAnimationFrame;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 768px)').matches || 'ontouchstart' in window;

  /* --- Scroll Reveal --- */
  function initScrollReveal(){
    var els = document.querySelectorAll('.cmd-reveal, .cmd-stagger, .cmd-img-reveal');
    if(!els.length) return;
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting) e.target.classList.add('is-visible');
      });
    }, {threshold: 0.08, rootMargin: '0px 0px -30px 0px'});
    els.forEach(function(el){ observer.observe(el); });
  }

  /* --- Animated Counters --- */
  function initCounters(){
    var els = document.querySelectorAll('[data-cmd-counter]');
    if(!els.length) return;
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting && !e.target.dataset.counted){
          e.target.dataset.counted = '1';
          animateCounter(e.target);
        }
      });
    }, {threshold: 0.3});
    els.forEach(function(el){ observer.observe(el); });
  }

  function animateCounter(el){
    var target = parseInt(el.dataset.cmdCounter, 10);
    var suffix = el.dataset.cmdSuffix || '';
    var dur = 2000, start = performance.now();
    function ease(t){ return t===1? 1 : 1 - Math.pow(2, -10*t); }
    function tick(now){
      var p = Math.min((now - start)/dur, 1);
      el.textContent = Math.round(ease(p)*target) + suffix;
      if(p<1) raf(tick);
    }
    raf(tick);
  }

  /* --- Parallax --- */
  function initParallax(){
    var els = document.querySelectorAll('[data-cmd-parallax]');
    if(!els.length || reducedMotion || isMobile) return;
    var ticking = false;
    function update(){
      var sy = window.pageYOffset;
      els.forEach(function(el){
        var speed = parseFloat(el.dataset.cmdParallax) || 0.15;
        var rect = el.getBoundingClientRect();
        if(rect.bottom > 0 && rect.top < window.innerHeight){
          var offset = (sy - (rect.top + sy)) * speed;
          el.style.transform = 'translate3d(0,'+offset+'px,0)';
        }
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ raf(update); ticking = true; }
    }, {passive:true});
  }

  /* --- Scroll Progress --- */
  function initScrollProgress(){
    var bar = document.querySelector('.cmd-scroll-progress');
    if(!bar) return;
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        raf(function(){
          var h = document.documentElement.scrollHeight - window.innerHeight;
          bar.style.transform = 'scaleX('+(h>0? window.pageYOffset/h : 0)+')';
          ticking = false;
        });
        ticking = true;
      }
    }, {passive:true});
  }

  /* --- Ripple on buttons --- */
  function initRipple(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.cmd-btn');
      if(!btn) return;
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var ripple = document.createElement('span');
      ripple.className = 'cmd-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size/2) + 'px';
      btn.appendChild(ripple);
      setTimeout(function(){ ripple.remove(); }, 700);
    });
  }

  /* --- Sticky Header --- */
  function initStickyHeader(){
    var header = document.querySelector('.cmd-header');
    if(!header) return;
    var last = 0, ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        raf(function(){
          var cur = window.pageYOffset;
          header.classList.toggle('cmd-header--scrolled', cur > 80);
          header.classList.toggle('cmd-header--hidden', cur > last && cur > 200);
          last = cur;
          ticking = false;
        });
        ticking = true;
      }
    }, {passive:true});
  }

  /* --- Tilt Cards --- */
  function initTilt(){
    if(isMobile) return;
    var cards = document.querySelectorAll('.cmd-tilt');
    cards.forEach(function(card){
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left)/r.width - 0.5;
        var y = (e.clientY - r.top)/r.height - 0.5;
        card.style.transform = 'perspective(800px) rotateY('+x*5+'deg) rotateX('+-y*5+'deg) translateY(-3px)';
      });
      card.addEventListener('mouseleave', function(){
        card.style.transform = '';
        card.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
        setTimeout(function(){ card.style.transition = ''; }, 500);
      });
    });
  }

  /* --- Timeline --- */
  function initTimeline(){
    var line = document.querySelector('.cmd-timeline__line-fill');
    var items = document.querySelectorAll('.cmd-timeline__item');
    if(!line || !items.length) return;
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('is-visible'); });
    }, {threshold: 0.15, rootMargin: '0px 0px -60px 0px'});
    items.forEach(function(i){ observer.observe(i); });

    var container = document.querySelector('.cmd-timeline');
    if(!container) return;
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        raf(function(){
          var r = container.getBoundingClientRect();
          var p = Math.min(Math.max((window.innerHeight - r.top)/r.height, 0), 1);
          line.style.transform = 'scaleY('+p+')';
          ticking = false;
        });
        ticking = true;
      }
    }, {passive:true});
  }

  /* --- Hero line reveal --- */
  function initHeroReveal(){
    var lines = document.querySelectorAll('.cmd-hero__line');
    if(!lines.length) return;
    lines.forEach(function(l, i){
      l.style.transitionDelay = (0.2 + i*0.15)+'s';
      setTimeout(function(){ l.classList.add('is-visible'); }, 100);
    });
  }

  /* --- Mobile menu --- */
  function initMobileMenu(){
    var toggle = document.querySelector('.cmd-header__mobile-toggle');
    var menu = document.querySelector('.cmd-header__nav');
    var overlay = document.querySelector('.cmd-header__overlay');
    var closeBtn = document.querySelector('.cmd-header__nav-close');
    if(!toggle || !menu) return;
    function closeMenu(){
      menu.classList.remove('is-open');
      toggle.classList.remove('is-active');
      document.body.style.overflow = '';
      if(overlay) overlay.classList.remove('is-visible');
    }
    toggle.addEventListener('click', function(){
      var open = menu.classList.toggle('is-open');
      toggle.classList.toggle('is-active');
      document.body.style.overflow = open? 'hidden':'';
      if(overlay) overlay.classList.toggle('is-visible');
    });
    if(closeBtn){ closeBtn.addEventListener('click', closeMenu); }
    if(overlay){
      overlay.addEventListener('click', function(){
        menu.classList.remove('is-open');
        toggle.classList.remove('is-active');
        document.body.style.overflow = '';
        overlay.classList.remove('is-visible');
      });
    }
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        menu.classList.remove('is-open');
        toggle.classList.remove('is-active');
        document.body.style.overflow = '';
        if(overlay) overlay.classList.remove('is-visible');
      });
    });
  }

  /* --- Init (each function wrapped in try/catch for resilience) --- */
  function init(){
    var fns = [
      initScrollReveal,
      initCounters,
      initParallax,
      initScrollProgress,
      initRipple,
      initStickyHeader,
      initTilt,
      initTimeline,
      initHeroReveal,
      initMobileMenu
    ];
    fns.forEach(function(fn){
      try { fn(); } catch(e) { console.warn('CMD init error:', e); }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
